import PropTypes from 'prop-types';
var AllhomesAgentModel = {
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  jobTitle: PropTypes.string,
  description: PropTypes.string,
  images: PropTypes.shape({
    profilePhoto: PropTypes.string
  }),
  address: PropTypes.shape({
    street: PropTypes.string.isRequired,
    suburb: PropTypes.string.isRequired,
    state: PropTypes.string.isRequired,
    postcode: PropTypes.string.isRequired,
    lat: PropTypes.number,
    lng: PropTypes.number,
    divisionId: PropTypes.number,
    zoomLevel: PropTypes.number
  }),
  website: PropTypes.string,
  emailContactable: PropTypes.bool,
  phone: PropTypes.string,
  agency: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    images: PropTypes.shape({
      logo: PropTypes.string
    }),
    logoBackgroundColour: PropTypes.string,
    profileUrl: PropTypes.string
  }).isRequired
};
export default AllhomesAgentModel;